var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { BsModalService } from "ngx-bootstrap";
import { FeedbackComponent } from "../components/feedback/feedback.component";
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal/bs-modal.service";
import * as i2 from "@angular/common/http";
var FeedbackService = /** @class */ (function () {
    function FeedbackService(modalService, http) {
        this.modalService = modalService;
        this.http = http;
        this.baseUrl = environment.baseUrlWs + environment.wsVerison;
    }
    FeedbackService.prototype.open = function (config) {
        this.initialState = __assign({}, config);
        var modalConfig = {
            initialState: this.initialState,
            class: config.modal.modalClass || "",
        };
        // console.log('modalConfig', modalConfig);
        this.bsModalRef = this.modalService.show(FeedbackComponent, modalConfig);
    };
    FeedbackService.prototype.createFeedback = function (type, rating, comment) {
        var _a;
        var url = this.baseUrl + "employer/feedbacks";
        var userData = JSON.parse(localStorage.getItem("userData"));
        var body = {
            usersId: String(userData["Teams"][0].employers_id),
            type: type,
            feedbacksValues: [
                {
                    key: "rating",
                    value: rating,
                },
                {
                    key: "comment",
                    value: comment,
                },
                {
                    key: "teamsId",
                    value: String(userData["Teams"][0].id),
                }
            ],
        };
        if (this.initialState.extraFeedbackValues) {
            (_a = body.feedbacksValues).push.apply(_a, this.initialState.extraFeedbackValues);
        }
        return this.http.post(url, body);
    };
    FeedbackService.ngInjectableDef = i0.defineInjectable({ factory: function FeedbackService_Factory() { return new FeedbackService(i0.inject(i1.BsModalService), i0.inject(i2.HttpClient)); }, token: FeedbackService, providedIn: "root" });
    return FeedbackService;
}());
export { FeedbackService };
